// rem.js - 设置1rem=100px的转换基准
(function (doc, win) {
  const docEl = doc.documentElement;
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  
  const setRemUnit = function () {
    // 设计稿宽度（这里假设为1920px）
    const designWidth = 1920;
    // 计算当前屏幕宽度与设计稿宽度的比例
    const scale = docEl.clientWidth / designWidth;
    // 设置根元素字体大小（100px = 1rem）
    docEl.style.fontSize = 100 * scale + 'px';
  };

  // 初始化
  setRemUnit();
  
  // 监听窗口大小变化
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, setRemUnit, false);
  doc.addEventListener('DOMContentLoaded', setRemUnit, false);
})(document, window);